import React from "react";

const LOGO_URL = "https://public-sleekbio.b-cdn.net/media/hsDcuXM54xpQxU96FHMGz0xTTryD9RoFcKYxorBF.jpg";
const BRAND_BLUE = "#0077B5";

/**
 * Canonical BrandHives logo lockup.
 * Blue "BrandHives" wordmark + bee icon + "by BHIVE™".
 *
 * @param {"sm"|"md"|"lg"|"footer"} size - sm=32px, md=36px, lg=44px, footer=28px
 * @param {boolean} showText - show "BrandHives" wordmark (default true)
 * @param {boolean} showSub - show "by BHIVE™" sub-text (default false)
 * @param {string} href - optional link wrapper
 * @param {object} style - extra container styles
 */
export default function BrandLogo({ size = "md", showText = true, showSub = false, href, style: extraStyle }) {
  const dims = { footer: 28, sm: 32, md: 36, lg: 44 }[size] || 36;
  const fontSize = { footer: 18, sm: 16, md: 21, lg: 26 }[size] || 21;
  const radius = size === "lg" ? 10 : size === "footer" ? 6 : 8;

  const inner = (
    <div style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none", ...extraStyle }}>
      <img
        src={LOGO_URL}
        alt="BrandHives logo"
        width={dims}
        height={dims}
        style={{ borderRadius: radius, objectFit: "cover" }}
      />
      {showText && (
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.1 }}>
          <span style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize, fontWeight: 700, color: BRAND_BLUE }}>
            BrandHives
          </span>
          {showSub && (
            <span style={{ fontSize: size === "footer" ? 11 : 10, color: "#888", fontWeight: 400 }}>by BHIVE™</span>
          )}
        </div>
      )}
    </div>
  );

  if (href) {
    return <a href={href} style={{ textDecoration: "none", color: "inherit" }} aria-label="BrandHives home">{inner}</a>;
  }
  return inner;
}

export { LOGO_URL, BRAND_BLUE };
